import axios from "./axios";
import { decryptdata, encryptdata } from "../../utils/encryptDecrypt";

const SECRET_KEY = process.env.REACT_APP_SECRET_KEY; 
console.log('SECRET_KEY', SECRET_KEY)

export const getApi = (url) =>
    new Promise((resolve, reject) => {
        axios
            .get(url)
            .then((response) => {
                if (response.data && response.data.error) reject(response.data.error);
                else resolve(response.data);
            })
            .catch((e) => reject(e));
    });


export const postApi = (url, data) =>
    new Promise((resolve, reject) => {
        // const datas = encryptdata(data);
        axios
            .post(url, data)
            .then((response) => {
                if (response.data && response.data.error) reject(response.data.error);
                else resolve(response.data);
            })
            .catch((e) => reject(e));
    });


export const putApi = (url, data) =>
    new Promise((resolve, reject) => {
        const datas = encryptdata(data);
        axios
            .put(url, {data:data})
            .then((response) => {
                if (response.data && response.data.error) reject(response.data.error);
                else resolve(response.data);
            })
            .catch((e) => reject(e));
    });

export const deleteApi = (url) =>
    new Promise((resolve, reject) => {
        axios
            .delete(url)
            .then((response) => {
                if (response.data && response.data.error) reject(response.data.error);
                else resolve(response.data);
            })
            .catch((e) => reject(e));
    });
